import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { BrandMigration } from "@obg/mat.ui.common";
import { ConfigService, FeatureFlagService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class LatestTermsAndConditionsConfigService {
	constructor(
		private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>,
		private featureFlagService: FeatureFlagService
	) {}

	latestTermsAndConditionsEnabled(): boolean {
		const brandMigration = this.featureFlagService.get<BrandMigration | undefined>(
			"mga_to_tobique_jurisdiction"
		)?.tobiqueMigration;
		if (brandMigration?.tobiquePostMigrationIsEnabled) {
			return true;
		}

		return this.configService.get((x) => x.commonUi?.latestTermsAndConditions?.isEnabled, false);
	}
}
